import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { HttpJavaService } from '../../../services/http-java-service/http-java.service';
import { UserTranslationService } from '../../../services/user-translation/user-translation.service';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  selector: 'app-tutorial-detail',
  templateUrl: 'tutorial-detail.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
})


export class TutorialDetailComponent {


  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('dangerModal', { static: false }) public dangerModal: ModalDirective;

  isLoading: boolean = false;
  isCreate: boolean = true;
  isFormTriedToSubmit: boolean = false;

  selectedImageSource: string;

  selectedBackgroundImage = null;
  selectedEnglishMediaFile = null;
  selectedArabicMediaFile = null;
  public countryList = [
    { labelEn: 'Bahrain', labelAr: 'البحرين', value: 'BH', },
    { labelEn: 'Saudi Arabia', labelAr: 'السعودية', value: 'SA', },
    { labelEn: 'UAE', labelAr: 'الإمارات', value: 'AE', },
    { labelEn: 'Qatar', labelAr: 'قطر', value: 'QA', },
    { labelEn: 'Kuwait', labelAr: 'الكويت', value: 'KW', },
    { labelEn: 'Oman', labelAr: 'عمان', value: 'OM', },
  ];



  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private httpJavaService: HttpJavaService,
    public userTranslationService: UserTranslationService,
    private toolService: ToolService,
  ) {

    const currentNavigationState = this.router.getCurrentNavigation()?.extras?.state;
    const tutorialData = currentNavigationState?.tutorial;
    if (tutorialData) {
      this.tutorialData = tutorialData;
      this.tutorialForm.get('country').patchValue(currentNavigationState?.country);
      this.selectedImageSource = this.tutorialData.backgroundImage;
      this.tutorialForm.patchValue(this.tutorialData);
      this.isCreate = false;
    } else {
      this.isCreate = true;
      this.tutorialForm.get('country').patchValue(this.countryList[0].value);

    }
  }



  tutorialData = {
    backgroundImage: null,
    descriptionAr: null,
    descriptionEn: null,
    icon: null,
    id: null,
    logDate: null,
    mediaLinkAr: null,
    mediaLinkEn: null,
    sort: null,
    status: null,
    titleAr: null,
    titleEn: null,
    userId: null
  };
  tutorialForm = this.formBuilder.group({
    backgroundImage: [null],
    descriptionAr: [null, [Validators.required]],
    descriptionEn: [null, [Validators.required]],
    icon: [null],
    id: [null],
    logDate: [null],
    mediaLinkAr: [null],
    mediaLinkEn: [null],
    sort: [null],
    status: [null, [Validators.required]],
    titleAr: [null, [Validators.required]],
    titleEn: [null, [Validators.required]],
    userId: [null],
    country: [null], // Extra
  });


  isFileValid(file) {
    if (this.isFormTriedToSubmit) {
      if (this.isCreate) {
        if (file) {
          return true;
        } else {
          return false;
        }
      } {
        return true;
      }
    }
    return null;
  }

  getFieldStatus(fieldName) {
    if (this.isFormTriedToSubmit) {
      return this.tutorialForm.get(fieldName).errors ? false : true;
    }
    return null;
  }

  get isFormValid() {
    this.isFormTriedToSubmit = true;
    return this.tutorialForm.valid;
  }

  formRawValue() {
    return this.tutorialForm.getRawValue();
  }

  async onFileSelect(event: any, type: 'background' | 'en-media' | 'ar-media') {
    const MAX_FILE_SIZE = 10 * 1024 * 1024;  // 10 MB
    let files = event.target.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.size > MAX_FILE_SIZE) {
        this.toastrService.error('File size exceeds the 10 MB limit!');
        return;
      }
      if (type == 'background') {
        const compressedImage = await this.toolService.compressImage(file);
        this.selectedBackgroundImage = compressedImage;
        const reader = new FileReader();
        reader.readAsDataURL(this.selectedBackgroundImage);
        reader.onload = (_event) => {
          this.selectedImageSource = reader.result.toString();
        }
      } else if (type == 'en-media') {
        this.selectedEnglishMediaFile = file;
      } else if (type == 'ar-media') {
        this.selectedArabicMediaFile = file;
      }
    }
  }

  deleteTutorial() {
    this.dangerModal.show();
  }

  async onCreateTutorial(): Promise<void> {
    if (this.isFormValid) {
      if (!this.selectedBackgroundImage || !this.selectedEnglishMediaFile || !this.selectedArabicMediaFile) {
        return;
      }
      this.isLoading = true;
      try {
        await this.uploadTutorialImage();
        await this.uploadTutorialEnglishMediaFile();
        await this.uploadTutorialArabicMediaFile();
        const tutorialData = this.formRawValue();
        const createResp = await this.httpJavaService.createTutorial(tutorialData, tutorialData?.country);
        this.toastrService.success("Tutorial created", "Success");
        await this.router.navigate(['../'], { relativeTo: this.activatedRoute });
        return createResp;
      } catch (err) {
        this.toastrService.error(err.description, "Error");
        throw err;
      } finally {
        this.isLoading = false;
      }
    }
  }

  async onUpdateTutorial(): Promise<void> {
    if (this.isFormValid) {
      this.isLoading = true;

      try {
        if (this.selectedBackgroundImage) {
          await this.uploadTutorialImage();
        }
        if (this.selectedEnglishMediaFile) {
          await this.uploadTutorialEnglishMediaFile();
        }
        if (this.selectedArabicMediaFile) {
          await this.uploadTutorialArabicMediaFile();
        }
        const tutorialData = this.formRawValue();
        const updateResp = await this.httpJavaService.updateTutorial(tutorialData, tutorialData?.country);
        this.toastrService.success("Tutorial updated", "Success");
        await this.router.navigate(['../'], { relativeTo: this.activatedRoute });
        return updateResp;
      } catch (err) {
        this.toastrService.error(err.description, "Error");
        throw err;
      } finally {
        this.isLoading = false;
      }
    }
  }


  onDeleteTutorial() {
    const tutorialData = this.formRawValue();
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.httpJavaService.deleteTutorial(tutorialData?.id, tutorialData?.country)
        .then(async res => {
          resolve(res);
          this.dangerModal.hide();
          this.toastrService.success("Tutorial deleted", "Success");
          this.router.navigate(['../'], { relativeTo: this.activatedRoute }).then(() => {
          });
        })
        .catch(err => {
          reject(err);
          this.dangerModal.hide();
          this.toastrService.error(err.description, "Error");
        })
        .finally(() => this.isLoading = false);
    });
  }

  async uploadTutorialImage(): Promise<string> {
    this.isLoading = true;
    try {
      const filePath = await this.httpJavaService.uploadSignedFile(this.selectedBackgroundImage);
      this.selectedImageSource = filePath;
      this.tutorialData.backgroundImage = filePath;
      this.tutorialForm.get('backgroundImage').setValue(filePath);
      return filePath;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async uploadTutorialEnglishMediaFile(): Promise<string> {
    this.isLoading = true;
    try {
      const filePath = await this.httpJavaService.uploadSignedFile(this.selectedEnglishMediaFile);
      this.tutorialData.mediaLinkEn = filePath;
      this.tutorialForm.get('mediaLinkEn').setValue(filePath);
      return filePath;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async uploadTutorialArabicMediaFile(): Promise<string> {
    this.isLoading = true;
    try {
      const filePath = await this.httpJavaService.uploadSignedFile(this.selectedArabicMediaFile);
      this.tutorialData.mediaLinkAr = filePath;
      this.tutorialForm.get('mediaLinkAr').setValue(filePath);
      return filePath;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      this.isLoading = false;
    }
  }




}
